export const AUTH_UNKNOWN = 'UNKNOWN'
export const AUTHENTICATED = 'AUTHENTICATED'
export const UNAUTHENTICATED = 'UNAUTHENTICATED'

export const LOGIN_STATE = {
  WAITING_FOR_EMAIL: 'WAITING_FOR_EMAIL',
  EMAIL_LINK_SENT: 'EMAIL_LINK_SENT',
  REDIRECTING: 'REDIRECTING',
}

const REACH_DOMAIN = 'reach.nz'

export const CUSTOM_OAUTH_PARAMETERS = {
  hd: `${REACH_DOMAIN}`,
  prompt: 'select_account',
}

/**
 * Role codes exactly as the permissions API returns them.
 *
 * These strings must byte-match the gateway. CALL_CENTRE is stored truncated to
 * ten characters upstream, which is why its value is not simply its name.
 */
export const USER_ROLES = {
  ORG_ADMIN: 'ORG_ADMIN',
  CALL_CENTRE: 'CALL_CENTR',
  REACH: 'REACH',
  BETA_TESTER: 'BETA',
  HEAD_OFFICE: 'HEAD_OFFICE',
  STORE_OWNER: 'STORE_OWNER',
  STORE_MANAGER: 'STORE_MANAGER',
}

/**
 * Audience for the Delivery Report.
 *
 * One derived token decides which view renders, per ADR-003. A token rather
 * than a boolean, because head office is a third audience and because "not
 * known yet" is a real state that needs a screen of its own.
 */
export const DELIVERY_AUDIENCE = {
  STAFF: 'STAFF',
  HEAD_OFFICE: 'HEAD_OFFICE',
  STORE: 'STORE',
  UNKNOWN: 'UNKNOWN',
}

export const GOOGLE_SIGN_IN_DOMAINS = [REACH_DOMAIN]

export const PERMISSION = {
  BRIEF: 'BRIEF',
  QUOTE: 'QUOTE',
  CALCULATOR: 'CALCULATOR',
  DELIVERY_REPORT: 'DELIVERY_REPORT',
  // The customer-facing counterpart. Deliberately its own function rather than
  // the staff report, so the permissions service never reports that a customer
  // holds a staff capability. See ADR-003.
  MY_DELIVERIES: 'MY_DELIVERIES',
  // The customer's own store list, read only. Its own function for the same
  // reason as MY_DELIVERIES: a customer must never hold a staff capability.
  MY_STORES: 'MY_STORES',
  TICKETS: 'TICKETS',
  CREATE_TICKET: 'CREATE_TICKET',
  DELIVERY_STATUS: 'DELIVERY_STATUS',
  CHECK_DELIVERY: 'CHECK_DELIVERY',
  UI_TEST: 'UI_TEST',
}
